import { connect } from 'react-redux'
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var AccountPlans = require("lib/account/AccountPlans");
var Spinner = require("components/utility/Spinner");
var ProgressBar = require("components/utility/ProgressBar");
var LoadingButton = require("components/utility/LoadingButton");

@connect(
  (state, props) => {
    var id = CurrentUser.get().id
    return {
      admin:  RosterSelectors.admin({state, id})
    }
  },

  (dispatch, props) => {
    var userID = CurrentUser.get().id

    return {
      populateData: () => {
        return dispatch(RosterActions.fetchAdmins({filter:{id: userID}, embeds:["admin.referred_by","admin.referred_count"]}))
      },
      updateReferralCode: (referralCode) => {
        return dispatch(RosterActions.updateAdmin({
          id: userID,
          update: { referred_by: referralCode, features: AccountPlans.PRODUCTS.WR_SILVER },
          embeds: ["admin.referred_by","admin.referred_count"]
        }))
      },
      sendReferralEmail: () => {
        return dispatch(RosterActions.updateAdmin({
          id: currentUserID,
          update: { referred_email: userInput },
          embeds: ["admin.referred_by","admin.referred_count"]
        }))
      }
    }
  }
)

@providePopulateData({waitForLoad:true})
class ReferralPreference extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = { loading: false }
  }

  // catches an error in the ajax call
  onServerError() {
    this.setState({ submitError: true, submitErrorMessage: 'Something went went wrong. Please refresh the page and try again or contact support.', loading: false})
  }
  // display invalid referral message
  invalidReferralCode(title, text) {
    window.wrNotifications.triggerDropDownNotification({ title: title, text: text, icon: "exclamation-sign", type: "error" })
  }
  // display valid referral message

  validReferralEmail() {
      window.wrNotifications.triggerDropDownNotification({ title: "The Email has been Sent!", icon: "ok-sign" })
  }
  // submits referral code
  onSubmitReferralCode() {
    var referralCode = this.refs.referralCode.value.trim()
    if (referralCode === this.props.admin.referral_code) {
      this.invalidReferralCode("Invalid referral code", "You can\'t use your own referral code")
    } else {
      this.setState({loading: true})
      this.props.updateReferralCode(referralCode).then((response) => {
        
        this.setState({ loading: false });
        var errors = _.first(response.admins).errors;
        // display error or render success banner
        if (_.any(errors)) {
          this.invalidReferralCode("Invalid referral code", _.first(errors))
        } else {
          Mycroft.newEvent({ category: "Referrals", action: "settings-tab-referral" });
          window.wrNotifications.triggerDropDownNotification({ title: "Referral submitted successfully!", icon: "ok-sign" })
          window.location.reload();
        }
      });
    }
  }

  onSubmitReferralEmail() {
    this.props.updateReferral(userInput.trim(), inputType).then((response) => {
      this.setState({ loading: false });
      var errors = _.first(response.admins).errors;
      // display error or render success banner
      if (_.any(errors)) {
        this.setState({ submitError: true, submitErrorMessage: _.first(errors), loading: false })
      } else {
        this.validReferralCode(inputType);
      }
    });
  }
  // render error message below input field
  showErrorMessage() {
    if (this.state.submitErrorMessage && this.state.submitError) {
      return (<div className="errorMessageContainer"><p className="errorMessage">{this.state.submitErrorMessage}</p></div>)
    }
  }
  // renders input field or spinner
  renderInput(inputType) {
    
    return <input className="form-control referralCodeEmailInputField" type="text" placeholder="Email" onKeyDown={(e) => this.onKeyPress(e, inputType)} />
  }
  // determines if user has already used a referral code
  renderReferralCodeInput() {
    if (CurrentUser.isPremiumOrTrialAccount()) { return null }
    if (_.isEmpty(this.props.admin.referred_by)) {
      return (
        <div className="referralInputAreaContainer">
          <p className="referralInputHeader">Did someone refer you to Whooo's Reading? Enter their referral code below and you'll both receive an extra 15 days on your free trials of Whooo's Reading Silver.</p>
          <div className="referralInputContainer row">
            <div className="col-sm-4">
              <p className="referralCodeInputIntro">Enter referral code: </p>
            </div>
            <div className="col-sm-8">
                <input className="form-control referralCodeInputField" type="text" placeholder="Referral code" ref="referralCode"/>
                <LoadingButton className="btn buttonDefault" text="Submit" onClick={ this.onSubmitReferralCode } loading={ this.state.loading } />
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="referralInputAreaContainer">
          <p className="referralInputHeader">You successfully used the following referral code: <b>{ this.props.admin.referred_by }</b></p>
        </div>
      )
    }
  }

  renderReferralCode() {
    return (
      <div className='referrralPreferenceSection'>
        <p>Refer up to two teachers and they will receive <strong>15 days of free Silver.</strong></p>
        <div className="row">
          <div className="col-sm-5">
            <p>Your referal code: <span className="userReferralCode"><strong>{this.props.admin.referral_code}</strong></span></p>
          </div>
        </div>

      </div>
    )
  }

  renderSilverTrialProgress() {
    var extensionProgress = this.props.admin.referred_count * 15

    if (this.props.admin.referred_count == 0) {
      var progressBarMessage = "Waiting on 2 more referrals"
    } else if (this.props.admin.referred_count == 1) {
      var progressBarMessage = "Waiting on 1 more referral. Trial was extended by 15 days!"
    } else {
      var progressBarMessage = "You referred two or more teachers. Your trial was extended by 30 days!"
    }
    
    return (
      <div className='referrralPreferenceSection'>
        <p>Refer up to two teachers and receive <strong>15 days of free Silver per person.</strong></p>
        <div className="row">
          <div className="col-sm-5">
            <p className="userReferralCode">Your referal code: <span className="userReferralCode"><strong>{this.props.admin.referral_code}</strong></span></p>
          </div>
          <div className="col-sm-7">
            <ProgressBar current={extensionProgress} total={30} className="levelBar" message={progressBarMessage} />
          </div>
        </div>

      </div>
    )
  }

  renderAdminReferralCodeSection() {
    return CurrentUser.isPremiumOrTrialAccount() ? this.renderReferralCode() : this.renderSilverTrialProgress()
  }

  renderEmailReferralInput() {
    return (
        <div className="referralInputAreaContainer referrralPreferenceSection">
          <p className="referralInputHeader">Do you know someone who'd love Whooo's Reading? Send them an email and we will attribute a referral to your account.</p>
          <div className="referralEmailInputContainer">
            {this.renderInput()}
            {this.showErrorMessage()}
          </div>
        </div>
      )
  }

  render() {

    return (
      <div className="referralContainer">
        { this.renderReferralCodeInput() }
        { this.renderAdminReferralCodeSection() }
        
      </div>
    )
    
  }
}


ReferralPreference.WrappedComponent.propTypes = StrictPropTypes({
  // Handlers from @connect
  populateData: PropTypes.func,
  updateReferralCode: PropTypes.func,
  sendReferralEmail: PropTypes.func,
  admin: PropTypes.object
});

module.exports = ReferralPreference;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/ReferralPreference.js